module.exports = __webpack_public_path__ + "static/media/info.ff36aabd.svg";